import React from 'react';
import { TryOn } from './TryOn';

export default function App() {
    return (
        <div className="App">
            <TryOn />
        </div>
    );
}
